// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"00aa2451","84":"79117c61","247":"2648dd6f","627":"61af2a03","834":"f3c466df","867":"49452f00","923":"6f78c452"}[chunkId] + ".chunk.js";
};